"use strict";

angular.module('rmPresenter')
    .controller('PresenterOverviewCtrl', require('./presenter_overview_ctrl'))
    .controller('PresenterFormCtrl', require('./presenter_form_ctrl'));

